import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Footer from "../layouts/Footer";
import Breadcrumb from "../layouts/Breadcrumb";
import AgentInbox from "../chat/AgentInbox";

const AgentMessages = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Buy Home For Less | Agent Messages</title>
      </Helmet>
      <Header />
      <Breadcrumb breadcrumb={{ pagename: "Agent Messages" }} />
      <div className="section">
        <div className="container">
          <AgentInbox />
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default AgentMessages;

